import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const UploadApi = createApi({
  reducerPath: "uploadApi",
  //   http://172.30.30.87:8337/api/upload
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["uploadBannerExpense"],
  endpoints: (builder) => ({
    updateUpload: builder.mutation({
      query: (data) => ({
        url: `/proxy/asset/api/upload`,
        headers: {
          service: "strapi"
        },
        method: "POST",
        body: data
      }),
      extraOptions: { service: "Strapi" }
    }),
    deleteUploadFile: builder.mutation({
      query: (id) => ({
        url: `/proxy/asset/api/upload`,
        headers: {
          service: "strapi"
        },
        method: "DELETE"
      }),
      extraOptions: { service: "Strapi" }
    })
  })
});

export const { useUpdateUploadMutation, useDeleteUploadFileMutation } =
  UploadApi;
